import * as Yup from 'yup';

const phoneRegex = /^\+?[0-9]{7,15}$/;

export const validationSchema = Yup.object().shape({
  // -------------------- Student Basic --------------------
  studentName: Yup.string()
    .matches(/^[A-Za-z ]{2,}$/, 'Enter at least 2 letters')
    .required('Student Name is required'),

  firstName: Yup.string()
    .matches(/^[A-Za-z ]{2,}$/, 'Enter at least 2 letters')
    .required('First Name is required'),

  lastName: Yup.string()
    .matches(/^[A-Za-z ]{2,}$/, 'Enter at least 2 letters')
    .required('Last Name is required'),

  gender: Yup.string().required('Gender is required'),

  // classId: Yup.string().required('Class is required'),
  currentClass: Yup.string().required('Current Class is required'),
  syllabus: Yup.string().required('Syllabus is required'),
  medium: Yup.string().required('Medium is required'),

  studentCountryCode: Yup.string().required('Student country code is required'), // dropdown

  contactNumber: Yup.string()
    .matches(phoneRegex, 'Enter a valid phone number (7–15 digits, optional +)')
    .required('Contact Number is required'),

  whatsappNumber: Yup.string()
    .matches(phoneRegex, 'Enter a valid WhatsApp number (7–15 digits, optional +)')
    .required('Whatsapp Number is required'),

  dateOfBirth: Yup.string().required('Date of birth is required'),

  bloodGroup: Yup.string().required('Blood group is required'),

  email: Yup.string().email('Invalid email format').required('Email is required'),

  // -------------------- Father --------------------
  fatherName: Yup.string()
    .matches(/^[A-Za-z ]{2,}$/, 'Enter at least 2 letters')
    .required('Father Name is required'),

  fatherQualification: Yup.string()
    .matches(/^[A-Za-z ]{2,}$/, 'Enter at least 2 letters')
    .required('Father Qualification is required'),

  fatherOccupation: Yup.string()
    .matches(/^[A-Za-z ]{2,}$/, 'Enter at least 2 letters')
    .required('Father Occupation is required'),

  fatherCountryCode: Yup.mixed().required('Father Country Code is required'),
  motherCountryCode: Yup.mixed().required('Mother Country Code is required'),

  fatherContactNumber: Yup.string()
    .matches(phoneRegex, 'Enter a valid phone number (7–15 digits, optional +)')
    .required('Father contact number is required'),

  // -------------------- Mother --------------------
  motherName: Yup.string()
    .matches(/^[A-Za-z ]{2,}$/, 'Enter at least 2 letters')
    .required('Mother Name is required'),

  motherQualification: Yup.string()
    .matches(/^[A-Za-z ]{2,}$/, 'Enter at least 2 letters')
    .required('Mother Qualification is required'),

  motherOccupation: Yup.string()
    .matches(/^[A-Za-z ]{2,}$/, 'Enter at least 2 letters')
    .required('Mother Occupation is required'),

  motherMobileNumber: Yup.string()
    .matches(phoneRegex, 'Enter a valid phone number (7–15 digits, optional +)')
    .required('Mother Mobile Number is required'),
  // -------------------- Guardian --------------------
  guardian: Yup.string()
    .matches(/^[A-Za-z ]{2,}$/, 'Enter at least 2 letters')
    .required('Guardian is required'),

  relationWithStudent: Yup.string().required('Relation with student is required'),

  // -------------------- Optional --------------------
  siblings: Yup.array().of(
    Yup.object().shape({
      name: Yup.string()
        .matches(/^[A-Za-z ]{2,}$/, 'Enter at least 2 letters')
        .nullable(),
      age: Yup.string()
        .matches(/^[0-9]+$/, 'Only numbers allowed')
        .nullable(),
      class: Yup.string().nullable(),
    })
  ),

  trainerPreference: Yup.string()
    .matches(/^[A-Za-z ]{2,}$/, 'Enter at least 2 letters')
    .required('Trainer Preference is required'),

  languageFluency: Yup.array().of(Yup.string()).min(1, 'Select atleast one').required('Language Fluency is required'),
});
